<script setup lang="ts">
import { useRootDatabase } from '@/composables/useRootDatabase.js'
const us = useUserStore()
const { auth } = storeToRefs(us)
if (!localStorage.getItem('coreui-vue-color-scheme')) localStorage.setItem('coreui-vue-color-scheme', 'light')

const { initializeDatabase } = useRootDatabase()

watchEffect(() => {
  if (auth.value == 'Authenticated') {
    initializeDatabase()
  }
})
</script>

<template>
  <RouterView />
</template>
